import React from "react";
import { Column, Columns, Table, TextArea } from "@allxsmith/bestax-bulma";



class PrintGoodsDelivery extends React.Component {

    render() {
        let data = this.props.movement;

        return (
            <div className={"print-portrait"}>
                <Columns isMultiline>
                    <Column>
                        <Table isFullwidth isBordered>
                            <tbody>
                                <tr>
                                    <th colSpan={12} className={"table-header-bold border-black fill-grey"}>DIRECT VEHICLE RECOVERY</th>
                                </tr>
                                <tr>
                                    <th colSpan={12} className={"table-header-bold border-black fill-grey"}>GOODS DELIVERY NOTE</th>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"table-header-bold fill-grey border-black"}>INTERNAL COMMENTS</td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"border-black"}>
                                        <TextArea
                                            value={data ? data.comments : ""}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"table-header-bold fill-grey border-black"}>JOB COMMENTS</td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"border-black"}>
                                        <TextArea
                                            value={data ? data.supplier_comments : ""}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                   <td colSpan={12} className={"table-header-bold fill-grey border-black"}>COLLECTION:</td>
                                </tr>
                                <tr>
                                   <td colSpan={12} className={"out-border-middle-left-black out-border-middle-right-black"}>{data ? data.start_address : ""}</td>
                                </tr>
                                <tr>
                                   <td colSpan={12} className={"out-border-middle-left-black out-border-middle-right-black out-border-bottom-black"}> </td>
                                </tr>
                                <tr>
                                   <td colSpan={12} className={"out-border-middle-left-black out-border-middle-right-black"}></td>
                                </tr>
                                <tr>
                                   <td colSpan={12} className={"out-border-middle-left-black out-border-middle-right-black out-border-bottom-black"}> </td>
                                </tr>
                                <tr>
                                   <td colSpan={12} className={"out-border-middle-left-black out-border-middle-right-black"}> </td>
                                </tr>
                                <tr>
                                   <td colSpan={12} className={"out-border-middle-left-black out-border-middle-right-black out-border-bottom-black"}> </td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"table-header-bold fill-grey border-black"}>DELIVERY:</td>
                                </tr>
                                <tr>
                                   <td colSpan={12} className={"out-border-middle-left-black out-border-middle-right-black"}>{data ? data.end_address : ""}</td>
                                </tr>
                                <tr>
                                   <td colSpan={12} className={"out-border-middle-left-black out-border-middle-right-black out-border-bottom-black"}> </td>
                                </tr>
                                <tr>
                                   <td colSpan={12} className={"out-border-middle-left-black out-border-middle-right-black"}> </td>
                                </tr>
                                <tr>
                                   <td colSpan={12} className={"out-border-middle-left-black out-border-middle-right-black out-border-bottom-black"}> </td>
                                </tr>
                                <tr>
                                   <td colSpan={12} className={"out-border-middle-left-black out-border-middle-right-black"}> </td>
                                </tr>
                                <tr>
                                   <td colSpan={12} className={"out-border-middle-left-black out-border-middle-right-black out-border-bottom-black"}> </td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"border-black fill-grey"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={1} className={"border-black fill-grey"}>No. of Items:</td>
                                    <td colSpan={5} className={"wide-column border-black"}></td>
                                    <td colSpan={3} className={"border-black fill-grey"}>Movement ID:</td>
                                    <td colSpan={3} className={"wide-column border-black"}>{data ? data.id : ""}</td>
                                </tr>
                                <tr>
                                    <td colSpan={1} className={"border-black fill-grey"}>Description:</td>
                                    <td colSpan={9} className={"wide-column out-border-middle-left-black out-border-bottom-black"}></td>
                                    <td colSpan={2} className={"wide-column out-border-bottom-black out-border-middle-right-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={1} className={"border-black fill-grey"}>Received in good condition:</td>
                                    <td colSpan={5} className={"wide-column border-black"}>YES</td>
                                    <td colSpan={6} className={"wide-column border-black"}>NO</td>
                                </tr>
                                <tr>
                                    <td colSpan={1} className={"out-border-middle-right-black out-border-middle-left-black out-border-top-black fill-grey"}>Signed:</td>
                                    <td colSpan={11} className={"wide-column out-border-top-black out-border-middle-left-black out-border-middle-right-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={1} className={"out-border-middle-right-black out-border-middle-left-black out-border-top-black out-border-bottom-black fill-grey"}></td>
                                    <td colSpan={11} className={"wide-column out-border-middle-left-black out-border-middle-right-black out-border-bottom-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={1} className={"border-black fill-grey"}>Print Name:</td>
                                    <td colSpan={11} className={"wide-column border-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={1} className={"border-black fill-grey"}>Date/Time:</td>
                                    <td colSpan={5} className={"wide-column border-black"}></td>
                                    <td colSpan={6} className={"wide-column border-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"border-black fill-grey"}>I acknowledge that I have read, understand, and agree to the Terms and Conditions. Which can be found on our web site www.dvrdeliveries.co.uk</td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"out-border-middle-left-black out-border-middle-right-black out-border-top-black"}>Direct vehicle recovery Ltd T/a DVR  JCR Units, Cherry Tree Road, Tibenham, Norwich, NR16 1PH</td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"out-border-middle-left-black out-border-middle-right-black out-border-bottom-black"}>T: 01953 528900</td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"out-border-middle-right-black out-border-middle-left-black out-border-top-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"out-border-middle-right-black out-border-middle-left-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"out-border-middle-right-black out-border-middle-left-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"out-border-middle-right-black out-border-middle-left-black"}></td>
                                </tr>
                                <tr>
                                    <td colSpan={12} className={"out-border-middle-right-black out-border-middle-left-black out-border-bottom-black"}>Notes</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Column>
                </Columns>
            </div>
        );

    }

}

export default PrintGoodsDelivery;